export default [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index/Index.vue'),
    redirect: to => {
      return '/home'
    }
  },
  {
    path: '/home',
    name: 'index',
    component: () => import('../views/index/Index.vue'),
    children: []
  },
  // 康熙字典
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import('../views/index/subpages/Dictionary.vue')
  },

  // 姓名吉凶
  {
    path: '/nameLuck',
    name: 'nameLuck',
    component: () => import('../views/index/subpages/luck/Index.vue')
  },
  {
    path: '/luckResult',
    name: 'luckResult',
    component: () => import('../views/index/subpages/luck/Result.vue')
  },

  // 梅花易数
  {
    path: '/plum',
    name: 'plumBlossomeI',
    component: () => import('../views/index/subpages/forecast/Forecast.vue'),
    children: [
      {
        path: 'report',
        name: 'report',
        component: () => import('../views/index/subpages/forecast/ForecastReport.vue')
      },
      {
        path: 'randomresult',
        name: 'randomresult',
        component: () => import('../views/index/subpages/forecast/ReportResult.vue')
      },
      {
        path: 'reportresult',
        name: 'reportresult',
        component: () => import('../views/index/subpages/forecast/ReportResult.vue')
      },
      {
        path: 'forecastresult',
        name: 'forecastresult',
        component: () => import('../views/index/subpages/forecast/ForecastResult.vue')
      }
    ]
  },

  // 八字命理
  {
    path: '/sizhu',
    name: 'sizhu',
    component: () => import('../views/index/subpages/sizhu/Index.vue')
  },
  {
    path: '/sizhuResult',
    name: 'sizhuResult',
    component: () => import('../views/index/subpages/sizhu/Result.vue')
  },

  // 风水罗盘
  {
    path: '/compass',
    name: 'compass',
    component: () => import('../views/index/subpages/Compass.vue')
  },

  // 预约咨询
  {
    path: '/consultation',
    name: 'consultation',
    component: () => import('../views/index/subpages/consultation/Consultation.vue')
  },

  {
    path: '/learn',
    name: 'learn',
    component: () => import('../views/course/Index.vue'),
    children: []
  },
  // 课程学习
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/course/Course.vue'),
    children: [
      {
        path: 'course_detail',
        name: 'courseDetail',
        component: () => import('../views/course/subpages/CourseDetail.vue')
      }
    ]
  },
  // 精选分享
  {
    path: '/article',
    name: 'article',
    component: () => import('../views/course/Article.vue'),
    children: [
      {
        path: 'article_detail',
        name: 'articleDetail',
        component: () => import('../views/course/subpages/ArticleDetail.vue')
      }
    ]
  },
  // 课程通知
  {
    path: '/notification',
    name: 'notification',
    component: () => import('../views/course/Notification.vue'),
    children: [
      {
        path: 'notification_detail',
        name: 'notificationDetail',
        component: () => import('../views/course/subpages/NotificationDetail.vue')
      },
      {
        path: 'sign',
        name: 'sign',
        component: () => import('../views/course/subpages/Sign.vue')
      }
    ]
  },

  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/shop/Index.vue'),
    children: []
  },
  {
    path: '/shopDetail/:id',
    name: 'shopDetail',
    component: () => import('../views/shop/subpages/ProductDetail.vue') },
  {
    path: '/Order/:id',
    name: 'Order',
    component: () => import('../views/shop/subpages/Order.vue') },
  {
    path: '/EditReceiveAddress',
    name: 'EditReceiveAddress',
    component: () => import('../views/shop/subpages/EditReceiveAddress.vue')
  },

  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/Index.vue'),
    children: [
      {
        path: 'userInfo',
        name: 'userInfo',
        component: () => import('../views/user/subpages/userInfo.vue'),
        children: [
          {
            path: 'modifyPassword',
            name: 'modifyPassword',
            component: () => import('../views/user/subpages/modifyPassword.vue')
          }
        ]
      },
      {
        path: 'myIntegral',
        name: 'myIntegral',
        component: () => import('../views/user/subpages/myIntegral.vue'),
        children: [
          {
            path: 'rechargePayTop',
            name: 'rechargePayTop',
            component: () => import('../views/user/subpages/rechargePayTop.vue')
          },
          {
            path: 'integralRule',
            name: 'integralRule',
            component: () => import('../views/user/subpages/integralRule.vue')
          }
        ]
      },
      {
        path: 'update',
        name: 'update',
        component: () => import('../views/user/subpages/update.vue')
      }
    ]
  }
]
